import { render, staticRenderFns } from "./NameBlock.vue?vue&type=template&id=aa1f0070&"
import script from "./NameBlock.vue?vue&type=script&lang=js&"
export * from "./NameBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports